import React from 'react';
import HeaderBanner from '../HeaderBanner';
import HeaderNav from '../HeaderNav';
import TabNav from '../TabNav';
import UtilityNav from '../UtilityNav';

type Props = {
  bannerText?: string;
  showBanner?: boolean;
  showTabNav?: boolean;
  showUtilityNav?: boolean;
  showHeaderNav?: boolean;
};

export const Header: React.FC<Props> = ({ bannerText, showHeaderNav = true, showUtilityNav = false, showBanner = false, showTabNav = false }) => {
  return (
    <>
      {showHeaderNav ? <HeaderNav /> : null}
      {showUtilityNav ? <UtilityNav /> : null}
      {showBanner ? <HeaderBanner text={bannerText} /> : null}
      {showTabNav ? <TabNav /> : null}
    </>
  );
};
